import React, { createContext, useCallback, useContext, useEffect, useState } from "react";

const LanguageContext = createContext({ lang: "de", setLang: () => {}, toggle: () => {} });

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "de";
    return window.localStorage.getItem("patrice.lang") || "de";
  });

  const setLang = useCallback((next) => {
    setLangState(next);
    if (typeof window !== "undefined") {
      window.localStorage.setItem("patrice.lang", next);
    }
  }, []);

  const toggle = useCallback(() => {
    setLang(lang === "de" ? "en" : "de");
  }, [lang, setLang]);

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;
    }
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);

// pick(string|{de,en}, lang)
export const pick = (entry, lang = "de") => {
  if (entry === null || entry === undefined) return "";
  if (typeof entry === "string") return entry;
  if (typeof entry === "object" && (entry.de || entry.en)) {
    return entry[lang] ?? entry.de ?? entry.en ?? "";
  }
  return String(entry);
};
